module.exports = {
      id: "gztrending-usage",
      viewBox: "0 0 18.806 24.145",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#gztrending",
      toString: function () {
        return this.url;
      }
    }